const MatchingResults = ({ showUrl, count, url }) => {
  const label = `VIEW ${count} LISTING${count === 1 ? "" : "S"}`;

  return (
    <div className="pull-right tw-mt-10px tw-mr-12px">
      {count === undefined ? (
        "Add search terms or map area to preview listings"
      ) : showUrl ? (
        <a className="tw-text-theme-primary tw-font-semibold tw-no-underline" href={url} target="_blank">
          {label}
        </a>
      ) : (
        <span className="tw-text-theme-primary tw-font-semibold">{label}</span>
      )}
    </div>
  );
};

export default MatchingResults;
